import { BaseDTO } from '../global/base.dto';

export class CalendarEventExcludedDateDTO extends BaseDTO {

    excludedDate: Date | string;

}
